/* eslint-disable import/prefer-default-export */
export function getDragWrapperStyle(
    isDragging: boolean,
    isDropping: boolean,
    isHoriz: boolean,
    xOffset: number,
    yOffset: number
) {
    const currentX = isHoriz
        ? `calc(${xOffset}px + var(--translate-x, 0px))`
        : `${xOffset}px`
    const currentY = isHoriz
        ? `${yOffset}px`
        : `calc(${yOffset}px + var(--translate-y, 0px))`

    const style = {
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? 0.6 : 1,
        // translate: isHoriz
        //     ? `var(--translate-x, 0px) 0px`
        //     : `0px var(--translate-y, 0px)`,
        transform: `translate3d(${currentX}, ${currentY}, 0)`,
        transition: isDragging
            ? 'none'
            : 'translate 250ms cubic-bezier(0.2, 0, 0, 1), transform 250ms cubic-bezier(0.2, 0, 0, 1)',
        filter:
            isDragging || isDropping
                ? 'drop-shadow(0px 5px 10px rgba(0,0,0,0.3))'
                : 'none',
        touchAction: 'none',
        zIndex: isDragging || isDropping ? 1000 : 1,
    }

    return style
}
